import React, { Component, Fragment } from "react";

//Component
import moment from "moment";
import Field from "../../Common/Field/Field";

export default class SampleModuleSelect extends Component {
  state = {
    selected: "",
    disabled: false,
    toggle: {}
  };

  componentWillMount() {
    const { disabled, selected, toggle } = this.props;
    this.setState({
      disabled,
      selected,
      toggle
    });
  }

  componentWillReceiveProps(nextProps) {
    const { disabled, selected, toggle } = nextProps;
    this.setState({
      disabled,
      selected,
      toggle
    });
  }

  //toggle
  // toggleChange = async (name, value) => {
  //     let toggle = { ...this.state.toggle }
  //     toggle[name] = value
  //     // await this.setState({ toggle })
  //     await this.props.toggleDataChange(toggle)
  // }

  moduleChoosen = e => {
    this.setState({
      selected: e.target.value
    });
    this.props.selectedModule(e.target.value);
  };

  render() {
    let { toggle, rights } = this.props;
    return (
      <div class="card-filter meeting-min-con" style={{ marginBottom: ".5%" }}>
        <div class="table-container">
          <form name="sampleRequestForm">
            <div class="col" style={{ paddingTop: "1%" }}>
              <div class="col-md-12 product-form no-padding">
                <div class="col-md-12 no-padding">
                  {this.state.productId !== undefined &&
                    this.state.productId !== "" && (
                      <Fragment>
                        <div class="col-md-1 step-one">
                          <div class="form-group">
                            <label for="date">Order Date</label>
                            <br />
                            <span>
                              {moment(this.state.orderDate).format(
                                "YYYY-MM-DD"
                              )}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-1 step-one">
                          <div class="form-group">
                            <label for="date">Request No.</label>
                            <br />
                            <span>{this.state.orderNumber}</span>
                          </div>
                        </div>
                      </Fragment>
                    )}
                </div>
              </div>

              <div className="col-md-12 product-form nopadding">
                <div className="col-md-8 mul-check check-padding">
                  <div className="">
                    <br />
                    <p className="radio-inline nopadding">
                      <input
                        name="group1"
                        type="radio"
                        className="filled-in hide-all"
                        id="rad1"
                        value="sampleRequest"
                        checked={this.state.selected === "sampleRequest"}
                        onChange={e => this.moduleChoosen(e)}
                      />
                      <label for="rad1">SAMPLE REQUEST</label>
                    </p>
                    <p className="radio-inline">
                      <input
                        name="group1"
                        type="radio"
                        className="filled-in hide-all"
                        id="rad2"
                        value="costingRequest"
                        checked={this.state.selected === "costingRequest"}
                        onChange={e => this.moduleChoosen(e)}
                      />
                      <label for="rad2">COSTING REQUEST</label>
                    </p>
                  </div>
                </div>
              </div>
              <div class="samp-req-con w-100">
                {this.state.dispatchId !== undefined &&
                  this.state.dispatchId !== "" && (
                    <div class="col-md-12" style={{ paddingTop: "10px" }}>
                      <a
                        onClick={() => this.props.history.push("/generateTag")}
                        class="primary"
                      >
                        generate tag
                      </a>
                    </div>
                  )}
                <div class="col-md-12">
                  <ul class="nav-locator">
                    {((rights.sample.web.view &&
                      this.props.action === "view") ||
                      (rights.sample.web.create &&
                        this.props.action === "add") ||
                      (rights.sample.web.edit &&
                        this.props.action === "edit")) &&
                      this.state.selected !== "costingRequest" && (
                        <Fragment>
                          <li>
                            <Field
                              isFormGroup={true}
                              inputType="checkboxToggle"
                              inputName="sample"
                              className={toggle.sample ? "" : "print-hidden"}
                              value={toggle.sample}
                              label="Sample"
                              onChange={this.props.toggleChange}
                              disabled={this.state.disabled}
                            />
                          </li>

                          {((rights.garmentTech.web.view &&
                            this.props.action === "view") ||
                            (rights.garmentTech.web.create &&
                              this.props.action === "add") ||
                            (rights.garmentTech.web.edit &&
                              this.props.action === "edit")) && (
                            <li>
                              <Field
                                isFormGroup={true}
                                inputType="checkboxToggle"
                                inputName="garmentTechnologist"
                                className={
                                  toggle.garmentTechnologist
                                    ? ""
                                    : "print-hidden"
                                }
                                value={toggle.garmentTechnologist}
                                label="garmentTech"
                                onChange={this.props.toggleChange}
                                disabled={this.state.disabled}
                              />
                            </li>
                          )}
                          {((rights.cad.web.view &&
                            this.props.action === "view") ||
                            (rights.cad.web.create &&
                              this.props.action === "add") ||
                            (rights.cad.web.edit &&
                              this.props.action === "edit")) && (
                            <li>
                              <Field
                                isFormGroup={true}
                                inputType="checkboxToggle"
                                inputName="cad"
                                className={toggle.cad ? "" : "print-hidden"}
                                value={toggle.cad}
                                label="3D"
                                onChange={this.props.toggleChange}
                                disabled={this.state.disabled}
                              />
                            </li>
                          )}
                        </Fragment>
                      )}
                    {((rights.fabric.web.view &&
                      this.props.action === "view") ||
                      (rights.fabric.web.create &&
                        this.props.action === "add") ||
                      (rights.fabric.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="fabric"
                          className={toggle.fabric ? "" : "print-hidden"}
                          value={toggle.fabric}
                          label="fabric"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.trim.web.view && this.props.action === "view") ||
                      (rights.trim.web.create && this.props.action === "add") ||
                      (rights.trim.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="trim"
                          className={toggle.trim ? "" : "print-hidden"}
                          value={toggle.trim}
                          label="trim"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.pattern.web.view &&
                      this.props.action === "view") ||
                      (rights.pattern.web.create &&
                        this.props.action === "add") ||
                      (rights.pattern.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="pattern"
                          className={toggle.pattern ? "" : "print-hidden"}
                          value={toggle.pattern}
                          label="pattern"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    <Fragment>
                      {((rights.cutting.web.view &&
                        this.props.action === "view") ||
                        (rights.cutting.web.create &&
                          this.props.action === "add") ||
                        (rights.cutting.web.edit &&
                          this.props.action === "edit")) &&
                        this.state.selected !== "costingRequest" && (
                          <li>
                            <Field
                              isFormGroup={true}
                              inputType="checkboxToggle"
                              inputName="cutting"
                              className={toggle.cutting ? "" : "print-hidden"}
                              value={toggle.cutting}
                              label="cutting"
                              onChange={this.props.toggleChange}
                              disabled={this.state.disabled}
                            />
                          </li>
                        )}
                      {((rights.sewing.web.view &&
                        this.props.action === "view") ||
                        (rights.sewing.web.create &&
                          this.props.action === "add") ||
                        (rights.sewing.web.edit &&
                          this.props.action === "edit")) &&
                        this.state.selected !== "costingRequest" && (
                          <li>
                            <Field
                              isFormGroup={true}
                              inputType="checkboxToggle"
                              inputName="sewing"
                              className={toggle.sewing ? "" : "print-hidden"}
                              value={toggle.sewing}
                              label="sewing"
                              onChange={this.props.toggleChange}
                              disabled={this.state.disabled}
                            />
                          </li>
                        )}
                    </Fragment>
                    {((rights.embellishment.web.view &&
                      this.props.action === "view") ||
                      (rights.embellishment.web.create &&
                        this.props.action === "add") ||
                      (rights.embellishment.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="embellishment"
                          className={toggle.embellishment ? "" : "print-hidden"}
                          value={toggle.embellishment}
                          label="embellishment"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.embroidery.web.view &&
                      this.props.action === "view") ||
                      (rights.embroidery.web.create &&
                        this.props.action === "add") ||
                      (rights.embroidery.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="embroidery"
                          className={toggle.embroidery ? "" : "print-hidden"}
                          value={toggle.embroidery}
                          label="embroidery"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.wash.web.view && this.props.action === "view") ||
                      (rights.wash.web.create && this.props.action === "add") ||
                      (rights.wash.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="wash"
                          className={toggle.wash ? "" : "print-hidden"}
                          value={toggle.wash}
                          label="wash"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {/* {this.state.selected !== "costingRequest" && ( */}
                    {/* <Fragment> */}
                    {((rights.dispatch.web.view &&
                      this.props.action === "view") ||
                      (rights.dispatch.web.create &&
                        this.props.action === "add") ||
                      (rights.dispatch.web.edit &&
                        this.props.action === "edit")) &&
                      this.state.selected !== "costingRequest" && (
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="dispatch"
                            className={toggle.dispatch ? "" : "print-hidden"}
                            value={toggle.dispatch}
                            label="dispatch"
                            onChange={this.props.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                      )}

                    {((rights.QC.web.view && this.props.action === "view") ||
                      (rights.QC.web.create && this.props.action === "add") ||
                      (rights.QC.web.edit && this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="qc"
                          className={toggle.qc ? "" : "print-hidden"}
                          value={toggle.qc}
                          label="Grading"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.marker.web.view &&
                      this.props.action === "view") ||
                      (rights.marker.web.create &&
                        this.props.action === "add") ||
                      (rights.marker.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="marker"
                          className={toggle.marker ? "" : "print-hidden"}
                          value={toggle.marker}
                          label="marker"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.costing.web.view &&
                      this.props.action === "view") ||
                      (rights.costing.web.create &&
                        this.props.action === "add") ||
                      (rights.costing.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="costing"
                          className={toggle.costing ? "" : "print-hidden"}
                          value={toggle.costing}
                          label="costing"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                    {((rights.signoff.web.view &&
                      this.props.action === "view") ||
                      (rights.signoff.web.create &&
                        this.props.action === "add") ||
                      (rights.signoff.web.edit &&
                        this.props.action === "edit")) && (
                      <li>
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="signOff"
                          className={toggle.signOff ? "" : "print-hidden"}
                          value={toggle.signOff}
                          label="signoff"
                          onChange={this.props.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/SampleModuleSelect/index.js